export default __webpack_public_path__ + "media/images/steps/hands-d8bf8ae11916e9c58ccde41fa3069d45.png";